const splitPageData = (basePage, comparePage, data) => {
    let splitBaseData = Array.apply(null, Array(basePage)).map(() => [])
    let splitCompareData = Array.apply(null, Array(comparePage)).map(() => [])
    for (let i = 0; i < data.length; i++) {
        let onceData = data[i]
        if (onceData.locationBase.length !== 0) {
            onceData.locationBase.forEach((item) => {
                // console.log(splitBaseData[item.pageNum - 1])
                splitBaseData[item.pageNum - 1].push({
                    diffIndex: onceData.diffIndex,
                    diffType: onceData.diffType,
                    locationShape: item,
                })
            })
        }
        if (onceData.locationCompare.length !== 0) {
            onceData.locationCompare.forEach((item) => {
                splitCompareData[item.pageNum - 1].push({
                    diffIndex: onceData.diffIndex,
                    diffType: onceData.diffType,
                    locationShape: item,
                })
            })
        }
    }
    return {
        baseData: splitBaseData,
        compareData: splitCompareData,
    }
}

const splitType = (basePage, comparePage, afterSplitPageData) => {
    let splitTypeBaseData = Array.apply(null, Array(basePage)).map(() => {
        return {delete: [], replace: [], insert: []}
    })
    let splitTypeCompareData = Array.apply(null, Array(comparePage)).map(() => {
        return {delete: [], replace: [], insert: []}
    })
    let baseData = afterSplitPageData.baseData
    let compareData = afterSplitPageData.compareData
    baseData.forEach((pageData, index) => {
        pageData.forEach((item) => {
            splitTypeBaseData[index][item.diffType].push(item)
        })
    })
    compareData.forEach((pageData, index) => {
        pageData.forEach((item) => {
            splitTypeCompareData[index][item.diffType].push(item)
        })
    })
    return {
        baseData: splitTypeBaseData,
        compareData: splitTypeCompareData,
    }
}

const splitListData = (basePage, comparePage, data) => {
    const resetData = data.map((item) => {
        if (item.locationBase.length === 0 || item.locationCompare.length === 0) {
            return {
                ...item,
                locationCompare: [
                    {
                        location: [
                            {
                                leftTop: {
                                    x: 0,
                                    y: 0,
                                },
                                rightBottom: {
                                    x: 579,
                                    y: 497,
                                },
                                leftBottom: {
                                    x: 455,
                                    y: 497,
                                },
                                rightTop: {
                                    x: 579,
                                    y: 459,
                                },
                            },
                        ],
                        pageNum: 1,
                    },
                ],
                locationBase: [
                    {
                        location: [
                            {
                                leftTop: {
                                    x: 0,
                                    y: 0,
                                },
                                rightBottom: {
                                    x: 646,
                                    y: 497,
                                },
                                leftBottom: {
                                    x: 336,
                                    y: 497,
                                },
                                rightTop: {
                                    x: 646,
                                    y: 456,
                                },
                            },
                        ],
                        pageNum: 1,
                    },
                ],
            }
        } else {
            return item
        }
    })
    const replaceData = resetData
        .filter((item) => item.diffType === "replace")
        .map((item) => {
            const basePos = item.locationBase
            const comparePos = item.locationCompare
            return {
                contentBase: item.contentBase,
                contentCompare: item.contentCompare,
                diffIndex: item.diffIndex,
                diffType: item.diffType,
                basePos: basePos,
                comparePos: comparePos,
                diffWords: item.diffwords,
                pageNumBase: item.pageNumBase,
                pageNumCompare: item.pageNumCompare,
            }
        })
    const deleteData = resetData
        .filter((item) => item.diffType === "delete")
        .map((item) => {
            const basePos = item.locationBase
            const comparePos = item.locationCompare
            return {
                contentBase: item.contentBase,
                contentCompare: item.contentCompare,
                diffIndex: item.diffIndex,
                diffType: item.diffType,
                basePos: basePos,
                comparePos: comparePos,
                diffWords: item.diffwords,
                pageNumBase: item.pageNumBase,
                pageNumCompare: item.pageNumCompare,
            }
        })
    const insertData = resetData
        .filter((item) => item.diffType === "insert")
        .map((item) => {
            const basePos = item.locationBase
            const comparePos = item.locationCompare
            return {
                contentBase: item.contentBase,
                contentCompare: item.contentCompare,
                diffIndex: item.diffIndex,
                diffType: item.diffType,
                basePos: basePos,
                comparePos: comparePos,
                diffWords: item.diffwords,
                pageNumBase: item.pageNumBase,
                pageNumCompare: item.pageNumCompare,
            }
        })
    return {
        insert: insertData,
        delete: deleteData,
        replace: replaceData,
    }
}

export const rewriteData = (data) => {
    try {
        const allData = data.diffDetailsList
        const basicInformation = data.diffSummary
        const {totalPagebase, totalpageCompare} = basicInformation
        const splitData = splitPageData(totalPagebase, totalpageCompare, allData)
        const splitTypeData = splitType(totalPagebase, totalpageCompare, splitData) // canvasData
        const splitList = splitListData(totalPagebase, totalpageCompare, allData) // listData
        const baseList = data.baseImageList.map((item) => {
            let baseImgSrc = ""
            if ("imageBase64" in item && item.imageBase64 !== null && item.imageBase64 !== undefined) {
                baseImgSrc = `data:image/png;base64,${item.imageBase64}`
            } else if ("imagePath" in item && item.imagePath !== null && item.imagePath !== undefined) {
                baseImgSrc = `${item.imagePath}`
            }
            return {
                imgSrc: baseImgSrc,
                imgWidth: item.imageWidth,
                imgHeight: item.imageHeight,
            }
        })
        const compareList = data.compareImageList.map((item) => {
            let compareImgSrc = ""
            if ("imageBase64" in item && item.imageBase64 !== null && item.imageBase64 !== undefined) {
                compareImgSrc = `data:image/png;base64,${item.imageBase64}`
            } else if ("imagePath" in item && item.imagePath !== null && item.imagePath !== undefined) {
                compareImgSrc = `${item.imagePath}`
            }
            return {
                imgSrc: compareImgSrc,
                imgWidth: item.imageWidth,
                imgHeight: item.imageHeight,
            }
        })
        return {
            baseList: baseList,
            compareList: compareList,
            compareData: {
                canvasData: splitTypeData,
                listData: splitList,
            },
            imageList: {
                baseList: baseList,
                compareList: compareList,
            },
            canvasData: splitTypeData,
            listData: splitList,
        }
    } catch (e) {
        throw new Error(`算法返回数据转换报错:${e}`)
    }
}
